import React from 'react';
import GuideCard from 'components/GuideCard';
import SparklesIcon from 'icons/Sparkles.icon';

type WorkflowGuideAnchorProps = {
  id: string;
  title: string;
  description: string;
};

// Hover tooltip that doubles as the guide tour's anchor for its step.
const WorkflowGuideAnchor: React.FC<WorkflowGuideAnchorProps> = (props) => {
  const { id, title, description } = props;

  return (
    <GuideCard
      onHover
      hasCloseButton={false}
      anchor={
        <span className="guide-anchor" id={id}>
          <SparklesIcon />
        </span>
      }
      title={title}
      description={description}
    />
  );
};

export default WorkflowGuideAnchor;
